import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { APP_TEXT_EN, APP_TEXT_ES, GTM, RELATIONSHIPS as guestRelationships, PostQuestIgnore, QAType } from 'src/app/shared/constants/app.constants';
import { GlobalService, Guest, IEventRegisterReq, IRegisterRequest, ResponderQuestionAnswer } from 'src/app/shared/services/global.service';
import { SharedDataService } from 'src/app/shared/services/registration.service';
import { UtilService } from 'src/app/shared/services/utils.service';
import { emailMatchValidator } from '../validator/registration.validator';
import { ZipAsyncValidator } from '../validator/zipLookup.validator';
import { ApiService } from 'src/app/shared/services/api.service';
import { catchError, concatMap, tap, throwError } from 'rxjs';
import {ReservationConfirmationComponent} from '../reservation-confirmation/reservation-confirmation.component';

@Component({
  selector: 'app-full-form',
  templateUrl: './full-form.component.html',
  styleUrls: ['./full-form.component.scss']
})

export class FullFormComponent implements OnInit {
 @ViewChild('scrollToRegister') scrolltarget!: ElementRef;
 mandatory:string = ' (required)' 
  public language: string = 'EN';
  public confirmationEvent:any;
  public multiEventRegistration: boolean = false;

  public events: any[] = [];
  public questions: any[] = [];
  public preQuestions: any[] = [];
  public postQuestions: any[] = [];
  public guestQuestions: any[] = [];
  public moreInfoQuestions: any[] = [];

  // public firstName: string = '';
  // public lastName: string = ''
  // public email: string = '';
  // public emailConfirm: string = '';
  // public streetAddress: string = '';
  // public zipCode: string = '';
  // public phone: string = '';
  // public guests: any[] = [];
   public eventIndex: number = 0;
  public mealOptions: string[] = [];
  public event: any;
  formRegistration!: FormGroup;
  showform!: number;
  personalInfo?:boolean;
  guestInfo?:boolean;
  moreInfo?:boolean;
  eventDateInfo?:boolean;
  // Form structure and fields.
  registrationForm: FormGroup = new FormGroup({});
  // If the form has been submitted, validation messages can be shown.
  public formSubmitted: boolean = false;
  guestNumbers: number[] = [];
  guestQuestionList: {
    questionLblText: string, qaId: string,
    answers: [{ displayValue: string, actualVal: string, correctAns: string }]
  }[] = [];
  moreInfoQuestionList: {
    questionLblText: string, qaId: string,
    answers: [{ displayValue: string, actualVal: string, correctAns: string }]
  }[] = [];
  showRegisterSection: boolean = false;
  showReservationConfirmation: boolean = false;
  guestRelationships:any = guestRelationships;
  langDictionary:any;
  eventDatesData:any;
  eventDatesDataCopy:any;
  eventToAttend:any;
  postQuesList!:any[]
  reservationData:any;
  isLoading = false;
  showReservationFailure=false;
  secondFormDisclaimer:string = '';
  ctaDisabled:boolean = false;
  showOptinDisclaimer:boolean = false
  isMultiEventSelect:boolean = true
  selectedEvent:any;
  selectedMultiEvents:any[] = [];
  multiEventError:boolean = false

  constructor(private zipAsyncValidator: ZipAsyncValidator, private sharedDataService: SharedDataService,
    private scrollService: UtilService, private formBuilder: FormBuilder,
    private globalService: GlobalService, private _ApiService:ApiService) { }

  ngOnInit(): void {    
    this.isMultiEventSelect = this.globalService.multiEvent;
    this.langDictionary = this.globalService.Language;    
    this.sharedDataService.currentData.subscribe(data => {
      if (data) {
        this.event = data;
        this.selectedEvent = data;
        this.guestNumbers = []
        this.personalInfo = true;
        this.guestInfo = false;
        this.moreInfo = false;
        this.secondFormDisclaimer = this.reservationData?.pageData?.disclaimers?.formDisclaimer;
        this.submitted = false;
        this.configureForm();   
        this.sharedDataService.disableCta(false)  ;
        this.formRegistration.markAsPristine();
        this.formRegistration.markAsUntouched();
        this.formRegistration.updateValueAndValidity({ onlySelf: false, emitEvent: false });
        this.showOptinDisclaimer = false;
      }
    });
    this.sharedDataService.eventListData.subscribe(data =>{
      this.eventDatesData = data;
      if (this.eventDatesData == null || !this.eventDatesData.length) {
        this.sharedDataService.disableCta(true);
      }
      if(this.eventDatesData && this.eventDatesData.length > 1){
        this.eventDateInfo = true;
      }else if(this.eventDatesData && this.eventDatesData.length == 1){
        this.eventDateInfo = false;
      }
    })




    this.globalService.jobInformation.subscribe((data) => {
      this.showform = 1;
      this.reservationData = data;      
      this.events = data.events || [];
      this.events = (data.events ?? []).filter((event:any) => event.EventId !== -1);
      this.questions = data.questions || [];
      this.preQuestions = this.questions.filter(q => q.CampaignQuestionType === 'Pre-Reservation');
      this.postQuestions = this.questions.filter(q => q.CampaignQuestionType === 'Post-Reservation');
      this.guestQuestions = this.questions.filter(q => q.CampaignQuestionType === 'GuestQualification');
      this.events = this.events.map(event => {
        const [datePart, timePartRaw] = event.EventDateTime.split('T');
        let [hour, minute] = timePartRaw.split(':');
        let hourNum = parseInt(hour, 10);
        const ampm = hourNum >= 12 ? 'pm' : 'am';
        hourNum = hourNum % 12 || 12;
        const timePart = `${hourNum}:${minute}${ampm}`;
        const dateObj = new Date(event.EventDateTime);
        const dayOfWeek = dateObj.toLocaleString('en-US', { weekday: 'long' });
        const dayOfWeekSpanish = dateObj.toLocaleString('es-ES', { weekday: 'long' });
        const month = dateObj.toLocaleString('en-US', { month: 'long' });
        const monthSpanish = dateObj.toLocaleString('es-ES', { month: 'long' });
        const day = dateObj.getDate();
        // Add suffix to day of month (e.g., 1st, 2nd, 3rd, 4th, etc.)
        const getDaySuffix = (d: number) => {
          if (d > 3 && d < 21) return 'th';
          switch (d % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
          }
        };
        const dayWithSuffix = `${day}${getDaySuffix(day)}`;
        const timeZone = event.TimeZone ? event.TimeZone.replace(/\s*\(.*?\)\s*/g, '').trim() : '';
        // return {
        //   ...event,
        //   date: datePart,
        //   time: timePart,
        //   dayOfWeek: dayOfWeek,
        //   dayOfWeekSpanish: dayOfWeekSpanish,
        //   month: month,
        //   monthSpanish: monthSpanish,
        //   day: day,
        //   dayWithSuffix: dayWithSuffix,
        //   timeZone: timeZone
        // };
      });
      this.sharedDataService.sendData(
        data.events[0]         
      )     
    }); 


    this.sharedDataService.ctaDisableData.subscribe(data=>{
      this.ctaDisabled = data;
    })
  }
  onChangeFocus(eventName:any){
    this.globalService.pushEvent({'event': 'field_engagement','field_name': eventName})
  }
  addConsumerInfo(){    
    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-US');

    const personalForn:any = this.personelInfoForm;
    this.globalService.pushEvent({'userData.firstName': personalForn.get('firstname').value})
    this.globalService.pushEvent({'userData.lastName': personalForn.get('lastname').value})
    this.globalService.pushEvent({'userData.zipCode': personalForn.get('zipcode').value})
    this.globalService.pushEvent({'userData.state': this.zipAsyncValidator.resolvedInfo?.stateId})
    this.globalService.pushEvent({'userData.email': personalForn.get('email').value})
    this.globalService.pushEvent({'userData.phone': personalForn.get('phone').value})
    this.globalService.pushEvent({'userData.phoneShort': "+1" + personalForn.get('phone').value.split("-").join("")})
    this.globalService.pushEvent({'userData.ip': this.globalService.ip})
    this.globalService.pushEvent({'userData.leadDate': formattedDate})
  }

  onEventChange(){
    this.eventDatesForm.get('attendEvent')?.valueChanges.subscribe((_item:any)=>{
      this.event =  this.eventDatesData?.filter((item:any) => item.eventId == _item)[0]?.eventData
      //this.configureForm();
      if(this.event){
        this.sharedDataService.sendData(this.event);
      }
      
    })
  }
  onGuestNoChange() {
    this.guestForm.get('guestnumber')?.valueChanges.subscribe((count: number) => {
      // const guests = this.guestsArray;
      // guests.clear(); // Clear previous guest forms


      const guests = this.guestsArray;
      const oldCount = guests.length;


      // REMOVE extra forms
      if (count < oldCount) {
        for (let i = oldCount - 1; i >= count; i--) {
          guests.removeAt(i);
        }
      }

      // ADD new forms
      if (count > oldCount) {
        for (let i = oldCount; i < count; i++) {
          guests.push(this.createGuestForm());
        }
      }

      if (count == 0) {
        // Get current control names
        const names = Object.keys(this.guestForm.controls);

        // Remove those starting with "gfq"
        for (const name of names) {
          if (name.startsWith('gfq')) {
            this.guestForm.removeControl(name);
          }
        }
        guests.clear();
        this.guestForm.updateValueAndValidity({ emitEvent: true });
      }
      this.prepareGuestQuestions(count)
      // for (let i = 0; i < count; i++) {
      //   guests.push(this.createGuestForm());
      // }
    });
  }
  onZipInput(event: any) {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
  }
  onPhoneInput(event: any): void {
    let input = event.target.value.replace(/\D/g, ''); // Remove non-digits
  
    // Prevent starting with 0 or 1
    if (input.length > 0 && (input[0] === '0' || input[0] === '1')) {
      input = input.slice(1); // Remove invalid first digit
    }
  
    // Format as ###-###-####
    if (input.length > 3 && input.length <= 6) {
      input = `${input.slice(0, 3)}-${input.slice(3)}`;
    } else if (input.length > 6) {
      input = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`;
    }
  
    event.target.value = input;
    this.personelInfoForm.get('phone')?.setValue(input, { emitEvent: false });
  }
  calculateAllowedGuests(currentEvent: any): { allowedGuests: number, canBringGuests: boolean } {
    const maxPerParty = currentEvent?.MaxPerParty - 1;
    const seatsLeft = (currentEvent?.MaxCapacity - currentEvent?.CurrentReservationCount) - 1;
    const _allowedGuestsNumber: number = (currentEvent?.IsWaitListOnly) ? maxPerParty : Math.min(maxPerParty, seatsLeft)
    const _canBringGuests: boolean = (_allowedGuestsNumber > 0 && currentEvent?.AllowGuests == true)? true : false;
    const returnObject = { allowedGuests: _allowedGuestsNumber, canBringGuests: _canBringGuests };
    return returnObject;
  }

  multiEventGuestNo(events: any): { allowedGuests: number, canBringGuests: boolean } | null {

    if (!events || events.length === 0) return null;

    var allWait = true;
    var allNotWait = true;


    for (var i = 0; i < events.length; i++) {
      if (events[i].eventData.IsWaitListOnly) allNotWait = false;
      else allWait = false;
    }

    //if all are in waitinglist
    if (allWait) {
      var minAmt = Infinity;
      for (var j = 0; j < events.length; j++) {
        var _maxPer = events[j].eventData.MaxPerParty - 1;
        if (_maxPer < minAmt) minAmt = _maxPer;
      }
      minAmt === Infinity ? null : minAmt;
      return { allowedGuests: minAmt, canBringGuests: true };
    }

    //if all are not-in waitinglist
    if (allNotWait) {

      var _minAmt = Infinity;
      for (var k = 0; k < events.length; k++) {
        const seatLeft = events[k].eventData.MaxCapacity - events[k].eventData.CurrentReservationCount
        var _minSeatsLeft = Math.min(events[k].eventData.MaxPerParty -1 , seatLeft - 1);
        if (_minSeatsLeft < _minAmt) _minAmt = _minSeatsLeft;
      }
      _minAmt === Infinity ? null : _minAmt;
      return { allowedGuests: _minAmt, canBringGuests: true };
    }

    //mix of waitinglist and non-waiting list, consider min of seatleft
    var _min = Infinity;
    for (var m = 0; m < events.length; m++) {
      if (!events[m].eventData.IsWaitListOnly) {
        const seatLeft = events[m].eventData.MaxCapacity - events[m].eventData.CurrentReservationCount;
        var _seatLeft = Math.min(events[m].eventData.MaxPerParty - 1, seatLeft - 1);
        if (_seatLeft < _min) _min = _seatLeft;
      }
    }
    _min === Infinity ? null : _min;
    return { allowedGuests: _min, canBringGuests: true };
  }

  
  handleMultiEvent(multiEventlist: any) {

    if (multiEventlist && multiEventlist.length) {
      this.guestNumbers = [];
      const selectedEvents = multiEventlist.filter((item: any) => item.checked);
      this.selectedMultiEvents = selectedEvents;
      if (selectedEvents && selectedEvents.length > 0) {
        this.multiEventError = false;
        const guestStatus: any = this.multiEventGuestNo(selectedEvents);
        this.guestInfo = true;
        for (let i = 0; i <= guestStatus.allowedGuests; i++) {
          this.guestNumbers.push(i);
        }   

        const guestSize = this.guestsArray?.length || 0;
        if (guestStatus?.allowedGuests < guestSize) {
          const sizeToRemove = guestSize - guestStatus?.allowedGuests;
          for (let i = 0; i < sizeToRemove; i++) {
            const lastIndex = this.guestsArray?.length - 1;
            if (lastIndex >= 0) {
              this.guestsArray.removeAt(lastIndex);
            }
          }
          //In this case make the dropdown selected velue retain.
          if (this.guestNumbers.includes(guestStatus.allowedGuests)) {
            this.guestForm.get('guestnumber')?.setValue(guestStatus.allowedGuests, { emitEvent: false });
          } else {
            this.guestForm.get('guestnumber')?.setValue(0, { emitEvent: true });
          }
        }
      }
    }

  }

validateMultiEvent(): boolean {
  return this.selectedMultiEvents.some(x => x.checked);
}

  prepareGuestQuestions(noOfGuests: number) {

    if (noOfGuests > 0) {
      this.guestQuestionList = [];
      const group: { [key: string]: FormControl } = {};
      this.guestQuestions = this.questions.filter(q => q.CampaignQuestionType === 'GuestQualification');
      this.guestQuestions.forEach((element, index) => {
        const _questionLblText = element.QuestionText;
        const _qaId = `gfq${element.CampaignQuestionId}`;
        const _answers = element.CampaignQuestionAnswers.map((item: any) => ({
          displayValue: item.Answer,
          actualVal: item.CampaignQuestionAnswerId,
          correctAns: item.QualificationOption
        })
        );
        this.guestQuestionList?.push({ questionLblText: _questionLblText, qaId: _qaId, answers: _answers });

        this.guestQuestionList?.forEach(item => {
          this.guestForm.addControl(item.qaId, new FormControl('', [Validators.required]))
          group[item.qaId] = new FormControl('')
        })
      })
    }else{
      this.guestQuestionList = [];
    }
  }
  prepareMoreInfoQuestions(moreInfoQuestions:any[]) {

      const group: { [key: string]: FormControl } = {};
      if(moreInfoQuestions?.length > 0){
        this.moreInfoQuestionList = [];
        moreInfoQuestions.forEach((element, index) => {
          const _questionLblText = element.QuestionText;
          const _qaId = `fq${element.CampaignQuestionId}`;
          const _answers = element.CampaignQuestionAnswers.map((item: any) => ({
            displayValue: item.Answer,
            actualVal: item.CampaignQuestionAnswerId,
            correctAns: item.QualificationOption
          })
          );
          this.moreInfoQuestionList?.push({ questionLblText: _questionLblText, qaId: _qaId, answers: _answers });
  
          this.moreInfoQuestionList?.forEach(item => {
            this.moreInfoForm.addControl(item.qaId, new FormControl('', [Validators.required]))
            group[item.qaId] = new FormControl('')
          })
        })
      }else{
        this.moreInfoQuestionList = [];
      }
  
    
  }

  prepareMoreinfoPostQues():any[]{
    const searchQuest = PostQuestIgnore;
    const moreInfoQuestions = this.postQuestions.filter(dataItem => !dataItem.QuestionText.toUpperCase().includes(searchQuest.toUpperCase()));
    if (moreInfoQuestions && moreInfoQuestions.length > 0){
      moreInfoQuestions?.forEach(item => {
        item.qaId = `sq-${item.CampaignQuestionId}`;
        this.moreInfoForm?.addControl(item.qaId, new FormControl(''))
        
      })
    }
    
    return moreInfoQuestions;
  }

  get eventDatesForm() {
    const eventDatesForm:any = this.getFormByType('form0');
    return eventDatesForm;
  }
  get personelInfoForm() {
    const personalInfoform:any = this.getFormByType('form1');
    return personalInfoform;
  }
  get guestForm() {
    const guestform:any = this.getFormByType('form2');    
    return guestform;
  }
  get moreInfoForm() {
    const guestform:any = this.getFormByType('form3');    
    return guestform
  }
  ngAfterViewInit() {
    this.scrollService.scroll$.subscribe(targetId => {
      if (targetId === 'scrollToRegister') {

        this.showRegisterSection = true;   
        this.configureForm();      
        setTimeout(() => {
          this.scrolltarget.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

      }
    });
  }


  onSubmitRegistration() {
  }

  updateMealOptions() {
    this.mealOptions = this.events[this.eventIndex]?.MenuItems || [];
    console.log(this.mealOptions);
    const contactInfoGroup = this.registrationForm.get('contactInfo') as FormGroup;
    if (this.mealOptions && this.mealOptions.length > 0) {
      if (!contactInfoGroup.get('mealSelection')) {
        contactInfoGroup.addControl('mealSelection', new FormControl('', Validators.required));
      }
    } else {
      if (contactInfoGroup.get('mealSelection')) {
        contactInfoGroup.removeControl('mealSelection');
      }
    }
  }


  // get typedFormSteps(): FormGroup[] {
  //   return (this.formRegistration.get('formsteps') as FormArray).controls as FormGroup[];
  // }


  get formsteps(): FormArray {
    return this.formRegistration.get('formsteps') as FormArray;
  }

  get visibleSteps(): AbstractControl[] {
    return this.formsteps.controls.filter((step, index) => this.shouldShowForm(index));
  }

  shouldShowForm(index: number): boolean {
    const step = this.formsteps.at(index);
    const formType = step.get('formType')?.value;
    // Example: show only form1 and form3
    return formType === 'formMultiEvent' || formType === 'form0' ||formType === 'form1' || formType === 'form3' || formType === 'form2';
  }


  get guestsArray(): FormArray {
    return this.guestForm.get('guests') as FormArray;
  }

  createGuestForm(): FormGroup {
    return this.formBuilder.group({
      guestfirstname: ['', Validators.required],
      guestlastname: ['', [Validators.required]],
      relationship: ['', [Validators.required]],
      //menuSelection: ['', [Validators.required]],
      ...(this.event.MenuItems && this.event.MenuItems.length ? { menuSelection: ['', Validators.required]}:[])
    });
  }

  onOptinChange(){
     this.personelInfoForm.get('textOptin')?.valueChanges.subscribe((val: string) => {
      this.showOptinDisclaimer = (val.toLowerCase() === "true");    
    });
  }
  configureForm() {   

    this.guestNumbers = [];
    const formsteps: FormGroup[] = [];
    const fromMultipleEvent =  this.eventDatesData?.filter((item:any) => item.eventId == this.event.EventId);
      const guestStatus: any = this.isMultiEventSelect?  this.multiEventGuestNo(fromMultipleEvent): this.calculateAllowedGuests(this.event);
      if (guestStatus.canBringGuests == true) {
        this.guestInfo = true;
        for (let i = 0; i <= guestStatus.allowedGuests; i++) {
          this.guestNumbers.push(i);
        }
      } else {
        this.guestInfo = false;
      }
  

      
      this.moreInfoQuestions = this.questions.filter(q => q.CampaignQuestionType === 'Pre-Reservation');
      if(this.moreInfoQuestions?.length > 0){
        this.moreInfo = true;
      }else {
        this.moreInfo = false;
      }
      
    if(this.isMultiEventSelect){
      formsteps.push( this.formBuilder.group({
        formType: 'formMultiEvent'
      }))
    }
    if(this.eventDateInfo == true && !this.isMultiEventSelect){
      formsteps.push( this.formBuilder.group({
        formType: 'form0',
        attendEvent: new FormControl(this.event.EventId),
      }))
    }
    if(this.personalInfo == true){
      formsteps.push( this.formBuilder.group({
        formType: 'form1',
        firstname: new FormControl('', [Validators.required]),
        lastname: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required, Validators.email]),
        confirm_email: new FormControl('', [Validators.required, Validators.email]),
        phone: new FormControl('',
          [
            Validators.required,
            Validators.pattern(/^[2-9]\d{2}-\d{3}-\d{4}$/),
          ]),
        address: new FormControl('', [Validators.required, Validators.minLength(5)]),
        zipcode: new FormControl('', {
          validators:[Validators.required, Validators.pattern(/^\d{5}$/)],
          asyncValidators: [this.zipAsyncValidator.validate.bind(this.zipAsyncValidator)],
        updateOn:'blur'
        }),
        ...(this.event.MenuItems && this.event.MenuItems.length ? { menuSelection: new FormControl('', [Validators.required])}:[])
        //menuSelection: new FormControl('', [Validators.required])
        ,
        textOptin: new FormControl('', [Validators.required])
      },{
        validators: emailMatchValidator()
      }
      ))
    }
    if(this.guestInfo == true){
      formsteps.push( this.formBuilder.group({
        formType: 'form2',
        guestnumber: new FormControl('', [Validators.required]),
        guests: this.formBuilder.array([])
      }))
      //this.onGuestNoChange();
    }
    if(this.moreInfo == true){
      formsteps.push(   this.formBuilder.group({
        formType: 'form3',
        question: new FormControl('')
      }))
    
    }
    this.formRegistration = this.formBuilder.group({
      formsteps: this.formBuilder.array(formsteps)
      
    });   
    
     if(this.guestInfo == true){
      this.onGuestNoChange();
     }
     if(this.moreInfo = true){
      this.prepareMoreInfoQuestions(this.moreInfoQuestions);
      this.postQuesList = this.prepareMoreinfoPostQues();
     }
     if(this.eventDateInfo == true && !this.isMultiEventSelect){
      this.onEventChange()
     }


    //this.updateMealOptions();

      this.onOptinChange();

    this.formSubmitted = false;
//this.formRegistration.reset();


    // this.registrationForm = new FormGroup({
    //   contactInfo: new FormGroup({
    //     firstName: new FormControl('', [Validators.required, Validators.minLength(2)]),
    //     lastName: new FormControl('', [Validators.required, Validators.minLength(4)]),
    //     email: new FormControl('', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    //     emailConfirm: new FormControl('', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    //     phone: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]),
    //     streetAddress: new FormControl('', [Validators.required, Validators.minLength(5)]),
    //     zip: new FormControl('', [Validators.maxLength(5), Validators.minLength(5)])  
    //   })
    // })


    // this.formBuilder.group(this.registrationForm);

    // let contactInfoGroup = this.registrationForm.get('contactInfo') as FormGroup;
  }

getFormByType(type: string): FormGroup | undefined {
  const formArray = this.formRegistration.get('formsteps') as FormArray;
  return formArray.controls.find((fg: AbstractControl) => fg.get('formType')?.value === type) as FormGroup;
}
  submitted = false;
  register() {
    this.submitted = true;

    if (this.isMultiEventSelect && 
      this.selectedMultiEvents && 
      !this.selectedMultiEvents.length ) {
      this.multiEventError = true;
      return;
    } else {
      this.multiEventError = false;
    }
    if(this.formRegistration.pending || this.formRegistration.invalid){
      this.formRegistration.markAllAsTouched();      
      return;
    } 

    // add consumer contact to gtm
    this.addConsumerInfo();
    //  Consumer Conversion
    this.globalService.pushEvent({'Consumer Conversion': 'Consumer Conversion'});
    this.createRegisterRequest();
  }
  createRegisterRequest() {
    this.isLoading = true;
    const reservationData = this.reservationData;

    const request: IRegisterRequest = {
      campaignId: reservationData.jobInfo.CampaignId,
      code: reservationData.jobCode,
      firstName: this.personelInfoForm.get('firstname').value,
      lastName: this.personelInfoForm.get('lastname').value,
      addressLine1: this.personelInfoForm.get('address').value,
      addressLine2: "",
      city: this.zipAsyncValidator.resolvedInfo?.cityName,
      state: this.zipAsyncValidator.resolvedInfo?.stateId,
      zip: this.personelInfoForm.get('zipcode').value,
      phone: this.personelInfoForm.get('phone').value,
      email: this.personelInfoForm.get('email').value,
      phoneType: "",
      audience_Key: 0
    }

   this._ApiService.addRespondent(request).pipe(
      concatMap((respondent: any) => {
        if(respondent.returnObject.responderId < 1){
          this.globalService.pushEvent({'Form Conversion ': 'Form Conversion'});
          this.globalService.pushEvent({'Unqualified Conversion': 'Unqualified Conversion'});
          return throwError(() => ({
            source:1
          }));

        }
        return this._ApiService.eventRegisteration(
          this.eventRegisterReq(Number(respondent.returnObject.responderId)))
      })
      ,
      catchError(err => {
        if(err.source == undefined){
          this.globalService.pushEvent({'Form Conversion ': 'Form Conversion'});
          this.globalService.pushEvent({'Unqualified Conversion': 'Unqualified Conversion'});
        }
        this.isLoading = false;
        //reservation failure//
        this.showRegisterSection=false;
        this.showReservationConfirmation=true;
        this.showReservationFailure=true;
        //reservation failure//
        return [];
      })

    )
     .subscribe(result => {
      const res:any = result;
       if (this.isMultiEventSelect) {
         const idMap = new Map(res.eventResults.map((s: any) => [s.eventId, s]));

         const result = this.eventDatesData
           .filter((m:any) => idMap.has(m.eventId))   
           .map((m:any) => {
             const resData:any = idMap.get(m.eventId);
             return {
               ...m.eventData,      
               titleVenue: m.titleVenue,     
               isTitle: m.isTitle,     
               eventResp: resData.reservationResponse,   
             };
           });
        //  const multiEventData = this.eventDatesData.map((item: any) => {
        //    return {
        //      ...item.eventData,
        //      titleVenue: item.title
        //    }
        //  })

          this.confirmationEvent = result;
       } else {
         const evenToOperate = this.eventDatesData?.find((item: any) => item.eventId == this.eventDatesForm?.get('attendEvent').value)
         const fromMultipleEvent: any = evenToOperate
           ? {
             ...evenToOperate.eventData,
             titleVenue: evenToOperate.titleVenue
           }
           : null;

         //const fromMultipleEvent =  this.eventDatesData?.filter((item:any) => item.eventId == this.eventDatesForm?.get('attendEvent').value)[0]?.eventData

         this.confirmationEvent = fromMultipleEvent ? [fromMultipleEvent] : [this.event];
       }
        this.isLoading = false; // hide spinner
        this.showRegisterSection=false;
        this.showReservationConfirmation=true;
        this.globalService.pushEvent({'Form Conversion ': 'Form Conversion'});
        this.globalService.pushEvent({'Qualified Conversion': 'Qualified Conversion'});
        result?.guests?.forEach((element:any) => {
          if(element.reservationBooked){
            this.globalService.pushEvent({'Guest Added': 'Guest Added'});
          }else{
            this.globalService.pushEvent({'Guest Failure': 'Guest Failure'});
          }
        });
        this.sharedDataService.disableCta(true)     
        this.scrollService.setSectionVisibility(false)
      })

  }

  eventRegisterReq(responderId: number): IEventRegisterReq {
    const reservationData = this.reservationData;
    const qualifyQaList: ResponderQuestionAnswer[] = this.qaList(QAType.QUALIFY)
    const surveyQaList: ResponderQuestionAnswer[] = this.qaList(QAType.SURVEY)
    const guestList: Guest[] = this.guestList();

    let confirmedEvents:any;
    if(this.isMultiEventSelect){
      confirmedEvents = this.selectedMultiEvents.map(item => item.eventId);
    } else{
      confirmedEvents = this.eventDatesForm?.get('attendEvent').value ? [this.eventDatesForm?.get('attendEvent').value] : [this.event.EventId];
    }
    const request: IEventRegisterReq = {
      responderId: responderId,
      eventIds: confirmedEvents,
      addQuestionAnswers_Qualifying: {
        responderQuestionAnswers: qualifyQaList
      },
      addReservation: {
        campaignId: reservationData.jobInfo.CampaignId,
        isWaitlist: this.event?.IsWaitListOnly,
        menuSelection: this.personelInfoForm.get('menuSelection')?.value || "",
        language: this.globalService.AppLanguage,
        PhoneOptIn: null,
        EmailOptIn: null,
        TextOptIn: this.personelInfoForm.get('textOptin')?.value === 'true'
      },
      addQuestionAnswers_Survey: {
        responderQuestionAnswers: surveyQaList
      },
      addGuestList: guestList
    }

    return request;
  }

  qaList(prefix: QAType): ResponderQuestionAnswer[] {
    const QaList: ResponderQuestionAnswer[] = []
    if (prefix == QAType.QUALIFY) {
      const qualifyQa1 = (this.guestForm) ? Object.keys(this.guestForm.controls)
        .filter(name => name.startsWith(QAType.QUALIFY_PREFIX1)) : [];
      const qualifyQa2 = (this.moreInfoForm) ? Object.keys(this.moreInfoForm.controls)
        .filter(name => name.startsWith(QAType.QUALIFY_PREFIX2)) : [];

      const combinedQa = [...qualifyQa1, ...qualifyQa2];
      combinedQa.forEach(item => {
        const qaObj: ResponderQuestionAnswer = {} as ResponderQuestionAnswer;
        qaObj.campaignQuestionId = Number(item.replace(/^gfq|^fq/, ""));
        qaObj.campaignQuestionAnswerId = (item.startsWith(QAType.QUALIFY_PREFIX1)) ? this.guestForm?.controls[item].value.actualVal : (item.startsWith(QAType.QUALIFY_PREFIX2)) ? this.moreInfoForm?.controls[item].value.actualVal : '';
        qaObj.answerText = '';
        QaList.push(qaObj);
      })
    }
    else if (QAType.SURVEY) {
      const qualifyQa = (this.moreInfoForm) ? Object.keys(this.moreInfoForm.controls)
        .filter(name => name.startsWith(QAType.SURVEY_PREFIX)) : [];

      qualifyQa.forEach(item => {
        const qaObj: ResponderQuestionAnswer = {} as ResponderQuestionAnswer;
        qaObj.campaignQuestionId = Number(item.replace(QAType.SURVEY_PREFIX, ""));
        qaObj.campaignQuestionAnswerId = 0;
        qaObj.answerText = this.moreInfoForm.controls[item].value;
        QaList.push(qaObj);
      })
    }

    //const QaList:ResponderQuestionAnswer[] = []
    // const _prefix = prefix;
    // const QaControls = (_prefix == 'gfq')?Object.keys(this.guestForm.controls)
    // .filter(name => name.startsWith(_prefix)):Object.keys(this.moreInfoForm.controls)
    // .filter(name => name.startsWith(_prefix))

    // QaControls.forEach(item => {
    //   const guestQaObj:ResponderQuestionAnswer = {} as ResponderQuestionAnswer;
    //   guestQaObj.campaignQuestionId = Number(item.replace(_prefix, ""));
    //   guestQaObj.campaignQuestionAnswerId = (_prefix == 'gfq')?this.guestForm.controls[item].value.actualVal:this.moreInfoForm.controls[item].value.actualVal;
    //   guestQaObj.answerText = (_prefix == 'gfq')?this.guestForm.controls[item].value.correctAns:this.moreInfoForm.controls[item].value.correctAns;
    //   QaList.push(guestQaObj);
    // })

    return QaList
  }

  guestList(): Guest[] {
    const guestList: Guest[] = []

    if (this.guestForm) {
      this.guestForm.value.guests.forEach((guest: any) => {
        const guestObj: Guest = {} as Guest;
        guestObj.firstName = guest.guestfirstname;
        guestObj.lastName = guest.guestlastname;
        guestObj.menuSelection = guest.menuSelection || "";
        guestObj.relationshipTypeId = guest.relationship;
        guestList.push(guestObj);
      })
    }

    return guestList;
  }
}
